import { Box, Inline, Text } from 'braid-design-system';

import { getDisplayCountOnNudgePill } from 'src/config/utils/getDisplayCountOnNudgePill';

import * as styles from './NudgePill.css';

interface NudgePillProps {
  label: string;
  count: number;
  isActive: boolean;
  id: string;
  isMobile: boolean;
  onClick: (id: string) => void;
  displayCount?: boolean;
}

export const NudgePill = ({
  label,
  count,
  isActive,
  id,
  isMobile,
  onClick,
  displayCount,
}: NudgePillProps) => (
  <Box
    data-automation="displayPills"
    key={id}
    role="button"
    onClick={() => onClick(id)}
    className={{
      [styles.nudgePill]: displayCount,
      [styles.nudgePillsWithoutCounts]: !displayCount,
      [styles.selectedNudgePill]: isActive,
    }}
    background={isActive ? 'customDark' : 'customLight'}
  >
    <Inline space="xxsmall" alignY="center" align="center">
      <Text size={isMobile ? 'small' : 'standard'}>{label}</Text>
      {displayCount && (
        <Box
          display="inline"
          background="positiveLight"
          paddingY="xxsmall"
          paddingX="xsmall"
          borderRadius="large"
        >
          <Text tone="positive" size="xsmall" weight="medium">
            {getDisplayCountOnNudgePill(count)}
          </Text>
        </Box>
      )}
    </Inline>
  </Box>
);
